import React from 'react';
import { FmSplit } from '../FmLayout';

interface StoryTransitionFrameProps {
  as?: 'div' | 'section';
  copy: React.ReactNode;
  capability?: React.ReactNode;
  tail?: React.ReactNode;
  className?: string;
  copyClassName?: string;
  capabilityClassName?: string;
  ariaLabel?: string;
  kind?: 'story-transition';
  conversionRole?: string;
}

/**
 * DS-internal stage frame for form-stage transitions. The copy reads as the
 * narrow rail beside the capability; geometry is the shared `copy-narrow`
 * split recipe, so the frame owns no column ratio of its own.
 */
export function StoryTransitionFrame({
  as: Element = 'div',
  copy,
  capability,
  tail,
  className,
  copyClassName,
  capabilityClassName,
  ariaLabel,
  kind,
  conversionRole,
}: StoryTransitionFrameProps): React.ReactElement {
  const copyNode = <div className={copyClassName}>{copy}</div>;
  return (
    <Element
      className={className}
      aria-label={ariaLabel}
      data-transition-frame="canonical"
      data-kind={kind}
      data-conversion-role={conversionRole}
    >
      {capability === undefined ? (
        copyNode
      ) : (
        <FmSplit
          balance="copy-narrow"
          side="end"
          contentSurface="plain"
          content={copyNode}
          graphic={<div className={capabilityClassName}>{capability}</div>}
        />
      )}
      {tail}
    </Element>
  );
}
